module.exports = __webpack_public_path__ + "img/micro.906ab3ed.png";